export default __webpack_public_path__ + "static/madeInFrance-65a4ee980bfe2848b45e012bd0c71652.png";